// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--dekDV","heading":"_93444fe79c--heading--EbW9q","dropdown":"_93444fe79c--dropdown--VKgO7"};